import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppComponent } from 'app/app.component';

@Component({
    selector: 'partner-inventory-all-products',
    templateUrl: './partner-inventory-all-products.component.html',
    styleUrls: ['./partner-inventory-all-products.component.scss'],
    providers: [MessageService]
})
export class PartnerInventoryAllProductsComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    constructor(private messageService: MessageService, public app: AppComponent) { }

    ngOnInit(): void { }
}
